function buildVerificationFilters(cgtStandard) {
  if (Object.keys(cgtStandard).length === 0) return null

  const filterParts = []
  let hasSubitems = false

  Object.entries(cgtStandard).forEach(([key, value]) => {
    if (value === true) {
      // Simple filter without subitems
      filterParts.push(key)
    } else if (Array.isArray(value)) {
      if (value.length > 0) {
        // Filter with subitems - specific subitems selected
        hasSubitems = true
        value.forEach(subitem => {
          filterParts.push(`${key}:${subitem}`)
        })
      } else {
        // Filter with subitems but none selected - apply main filter only
        filterParts.push(key)
      }
    }
  })

  if (filterParts.length === 0) return null

  // If there are subitems, return as array, otherwise return as single string
  return hasSubitems ? filterParts : filterParts[0]
}

export default buildVerificationFilters

